const getConfig = () => {
  // Use window.APP_CONFIG if available, otherwise use default values
  return window.APP_CONFIG || {
    API_BASE_URL: 'https://sat.excintec.com',
    API_BASE_PATH: '/api',
    UPLOADS_PATH: ''
  };
};

const config = getConfig();
const BASE_URL = config.API_BASE_URL;
const API_BASE_PATH = config.API_BASE_PATH;
const UPLOADS_PATH = config.UPLOADS_PATH;

export const API_CONFIG = {
  BASE_URL,
  API_BASE_PATH,
  UPLOADS_PATH,
  getImageUrl: (filepath) => `${BASE_URL}${UPLOADS_PATH}/${filepath}`
};

const API_ENDPOINTS = {
  SLIDER: `${BASE_URL}${API_BASE_PATH}/slider_api.php`,
  LOGO: `${BASE_URL}${API_BASE_PATH}/logo_api.php`,
  PRODUCTS: `${BASE_URL}${API_BASE_PATH}/products_api.php/products`,
  PRODUCT_IMAGES: `${BASE_URL}${API_BASE_PATH}/productimages_api.php/product`, 
  CATEGORIES: `${BASE_URL}${API_BASE_PATH}/categories_api.php/categories`,
  CLIENTS: `${BASE_URL}${API_BASE_PATH}/clients_api.php/clients`,
  ABOUTUS: `${BASE_URL}${API_BASE_PATH}/aboutus_api.php`,
  WEBSITESETTINGS: `${BASE_URL}${API_BASE_PATH}/settings_api.php/settings`,
  USERS: `${BASE_URL}${API_BASE_PATH}/users_api.php/users`
};

export const getApiUrl = (endpoint) => API_ENDPOINTS[endpoint];

export const getProductApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.PRODUCTS.replace('/products', '/product');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getProductImagesApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.PRODUCT_IMAGES.replace('/product', '/image');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getCategoryApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.CATEGORIES.replace('/categories', '/category');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getClientApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.CLIENTS.replace('/clients', '/client');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getWebSettingsApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.WEBSITESETTINGS.replace('/settings', '/setting');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getUserApiUrl = (id) => {
  const baseUrl = API_ENDPOINTS.USERS.replace('/users', '/user');
  return id ? `${baseUrl}?id=${id}` : baseUrl;
};

export const getForgotPasswordApiUrl = () => {
  return API_ENDPOINTS.USERS + '/forgot-password';
};

export default API_ENDPOINTS; 